export type WidgetPosition = 'bottom-end' | 'bottom-start' | 'top-end' | 'top-start'

export type LegacyWidgetPosition = 'bottom-right' | 'bottom-left'

export type AnyWidgetPosition = WidgetPosition | LegacyWidgetPosition

const LEGACY_MAP: Record<LegacyWidgetPosition, WidgetPosition> = {
  'bottom-right': 'bottom-end',
  'bottom-left': 'bottom-start',
}

const CANONICAL: ReadonlySet<string> = new Set<WidgetPosition>([
  'bottom-end',
  'bottom-start',
  'top-end',
  'top-start',
])

let legacyWarned = false

export function normalizePosition(input?: string | null): WidgetPosition {
  if (!input) return 'bottom-end'
  if (CANONICAL.has(input)) return input as WidgetPosition
  if (input in LEGACY_MAP) {
    if (!legacyWarned && typeof console !== 'undefined') {
      legacyWarned = true
      console.warn(
        `[reqdesk] position="${input}" is deprecated — use "${LEGACY_MAP[input as LegacyWidgetPosition]}" (logical side).`,
      )
    }
    return LEGACY_MAP[input as LegacyWidgetPosition]
  }
  return 'bottom-end'
}

export function positionSide(pos: WidgetPosition): 'start' | 'end' {
  return pos.endsWith('-end') ? 'end' : 'start'
}

export function positionBlock(pos: WidgetPosition): 'top' | 'bottom' {
  return pos.startsWith('top-') ? 'top' : 'bottom'
}
